import {
    IonButton,
    IonButtons,
    IonCol,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonRow,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import React, { useContext, useEffect, useState } from "react";
import Spinner from "../../Spinners/Spinner";
import { Alert, Block, Event, OrganizationAuditor, Organization } from "../../../models";
import ErrorAlert from "../../Errors/ErrorAlert";
import { chevronDown, chevronUp, close } from "ionicons/icons";
import InformationBanner from "../../Banners/InformationBanner";
import { getActiveOrganizationAuditorsWithFilterByOrganizationId } from "../../../utilities/organizationAuditor/OrganizationAuditor";
import { FormGroup, Input } from "reactstrap";
import { getValidBlocksByOrganizationId } from "../../../utilities/block/Block";
import { getCreditCountFromBlocks } from "../../../utilities/block/CreditCount";
import SelectEventAuditors from "../../EventAuditor/SelectEventAuditor";
import SelectEventAlertFiltersForm, { FormattedFilter } from "./SelectEventAlertFiltersForm";
import { getOrganizationAuditorsByFilters } from "../../../utilities/eventFilter/FilterOrganizationAuditors";
import { createAlert } from "../../../utilities/alerts/Alerts";
import { PersonContext } from "../../../context/PersonContext";
import { handleSendMassOrgSMS } from "../../../utilities/twilio/TwilioSMS";
import SuccessBanner from "../../Banners/SuccessBanner";
import BuyCreditsForm from "./BuyCreditsForm";
import { CreateAlertInput } from "../../../API";
import { useSubscriptionByItself } from "../../../utilities/subscription/Subscription";
import { onCreateBlock, onCreateOrganizationAuditor } from "../../../graphql/subscriptions";
import { sortBlocksByDateOldest } from "../../../utilities/block/SortBlocks";
import AlertImageForm from "./AlertImageForm";
import { createMMSPDFFileName, createMMSPictureFileName, handleUploadS3Image } from "../../../utilities/s3Object/s3Object";
import awsmobile from "../../../aws-exports";
import SelectEventFilterRolesOptionForm, { FormattedRoleOption } from "./EventFilterRolesOptionForm";
import { TextAlertRoleFilter, TextAlertRolesFilters, TextAlertRolesFiltersForIHSAFinals, TextAlertRolesFiltersForLAECOrg } from "../../../utilities/roles/Roles";
import constants from "../../../constant/constant";
import { calculateTotalMessageSegmentsInMessageBody, checkIfMessageBodyCanBeEncodedInGSM } from "../../../utilities/alerts/CalculateValuesForAlerts";
import { Result } from "../../../interfaces/Result";
import DatePicker from "../../DatePicker/DatePicker";
import TimePicker from "../../TimePicker";
import moment from "moment";
import ReactstrapDatePicker from "../../DatePicker/ReactstrapDatePicker";
import ReactstrapTimePicker from "../../TimePicker/ReactstrapTimePicker";

interface _Props {
    organization: Organization
}

export interface FormattedBlock {
    id: string
    creditsToUse: number
    setBlockToEmpty: boolean
    block: Block
}

const dateFormat = "YYYY-MM-DD";

const SendOrgAlertForm: React.FC<_Props> = ({organization}) => {
    const user = useContext(PersonContext);

    const blockSubscription = useSubscriptionByItself({
        config: {
            query: onCreateBlock,
            key: "onCreateBlock"
        }
    });

    const auditorSubscription = useSubscriptionByItself({
        config: {
            query: onCreateOrganizationAuditor,
            key: "onCreateOrganizationAuditor"
        }
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isCountingCreditsNeeded, setIsCountingCredits] = useState(false);
    const [currentBlockSubscriptionItem, setCurrentBlockSubscriptionItem] = useState<any>();
    const [currentAuditorSubscriptionItem, setCurrentAuditorSubscriptionItem] = useState<any>();
    const [isGeneral, setIsGeneral] = useState(true);
    const [isFiltered, setIsFiltered] = useState(false);
    const [isCustom, setIsCustom] = useState(false);
    const [formattedRoleOptions, setFormattedRoleOptions] = useState<FormattedRoleOption[] | null | undefined>();
    const [formattedFilters, setFormattedFilters] = useState<FormattedFilter[] | null | undefined>();
    const [organizationAuditors, setOrganizationAuditors] = useState<(OrganizationAuditor | OrganizationAuditor)[] | null | undefined>();
    const [selectedOrganizationAuditors, setSelectedOrganizationAuditors] = useState<(OrganizationAuditor | OrganizationAuditor)[] | null | undefined>();
    const [messageBody, setMessageBody] = useState("");
    const [characterCount, setCharacterCount] = useState(0);
    const [isEncodedWithGSM, setIsEncodedWithGSM] = useState(true);
    const [messageSegmentCount, setMessageSegmentCount] = useState(0);
    const [image, setImage] = useState<File | null | undefined>();
    const [imageMessage, setImageMessage] = useState("");
    const [creditsNeeded, setCreditsNeeded] = useState(0);
    const [formattedBlocks, setFormattedBlocks] = useState<FormattedBlock[] | null | undefined>();
    const [totalCreditCount, setTotalCreditCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showCreditsModal, setShowCreditModal] = useState(false);
    const [showScheduleOptions, setShowScheduleOptions] = useState(false);
    const [scheduleDate, setScheduleDate] = useState<string | null | undefined>(moment(new Date()).format(dateFormat));
    const [scheduleTime, setScheduleTime] = useState<string | null | undefined>(null);
    const [scheduleError, setScheduleError] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const formatEventRoleFilters = () => {
        let options: FormattedRoleOption[] = [];
        let selectedArray: string[] = [];
        let rolesList = TextAlertRolesFilters;
        if (organization.id === constants.IHSA_ORGANIZATION.id) rolesList = TextAlertRolesFiltersForIHSAFinals;
        else if (organization.id === "4413e377-8501-46db-a284-6e252b2d82eb") rolesList = TextAlertRolesFiltersForLAECOrg;
        if (rolesList) {
            for (var i = 0; i < TextAlertRolesFilters.length; i++) {
                const currentEventFilter: TextAlertRoleFilter = TextAlertRolesFilters[i];

                // For the roles filter, we typically will start with none selected and make the person pick
                let isSelected = true; 

                let childrenArray: (FormattedRoleOption[] | null) = null;

                if (currentEventFilter.children) {
                    childrenArray = [];
                    const childArray = currentEventFilter.children;
                    for (var j = 0; j < childArray.length; j++) {
                        const currentEventFilter: TextAlertRoleFilter = childArray[j];
        
                        // For the roles filter, we typically will start with none selected and make the person pick
                        let isChildSelected = true;

                        const formattedOption: FormattedRoleOption = {
                            name: currentEventFilter.name,
                            value: currentEventFilter.value,
                            isSelected: isChildSelected
                        };

                        childrenArray.push(formattedOption);
                    }
                }

                const formattedOption: FormattedRoleOption = {
                    name: currentEventFilter.name,
                    value: currentEventFilter.value,
                    isSelected: isSelected,
                    children: childrenArray || undefined
                };

                options.push(formattedOption);
                selectedArray.push(currentEventFilter.value);
            }
        }
        setFormattedRoleOptions(options);
    }
    async function getOrganizationAuditors(org: Organization) {
        const queryResult = await getActiveOrganizationAuditorsWithFilterByOrganizationId(org.id);
        if (queryResult.isSuccess) {
            setOrganizationAuditors(queryResult.result);

            // Start with all event auditors "selected"
            setSelectedOrganizationAuditors(queryResult.result);
        }
    }

    async function getOrganizationAuditorsAndFilter(event: Event) {
        const queryResult = await getActiveOrganizationAuditorsWithFilterByOrganizationId(event.id);
        if (queryResult.isSuccess) {
            const organizationAuditors = queryResult.result;
            setOrganizationAuditors(organizationAuditors);
            if (organizationAuditors) {
                if (isGeneral) {
                    setSelectedOrganizationAuditors(organizationAuditors);
                    calculateValues(undefined, organizationAuditors);
                } 
                else if (isFiltered && formattedRoleOptions && formattedFilters) {
                    const queryFilterResult = await getOrganizationAuditorsByFilters(organizationAuditors, formattedRoleOptions, formattedFilters);
                    if (queryFilterResult.isSuccess) {
                        setSelectedOrganizationAuditors(queryFilterResult.result);
                        calculateValues(undefined, queryFilterResult.result);
                    }
                } 
                else {
                    // No change
                }
            }
        }
    }

    function formatCreditBlocks(blocks: Block[]) {
        let results: FormattedBlock[] = [];
        blocks.forEach(block => {
            const formatted: FormattedBlock = {
                id: block.id,
                creditsToUse: 0,
                setBlockToEmpty: false,
                block: block
            };
            results.push(formatted);
        });
        setFormattedBlocks(results);
    }

    async function getBlocksByOrganizationId(organizationId: string) {
        if (organizationId) {
            const queryResult = await getValidBlocksByOrganizationId(organizationId);
            if (queryResult.isSuccess) {
                const sorted = sortBlocksByDateOldest(queryResult.result);
                formatCreditBlocks(sorted || queryResult.result);
                setTotalCreditCount(getCreditCountFromBlocks(queryResult.result));
            }
        }
    }

    useEffect(() => {
        if (organization) {
            formatEventRoleFilters();
            getOrganizationAuditors(organization);
            getBlocksByOrganizationId(organization.id);
        }
    }, [organization]);

    useEffect(() => {
        if (blockSubscription && blockSubscription[0] !== undefined && blockSubscription[0] !== currentBlockSubscriptionItem) {
            setCurrentBlockSubscriptionItem(blockSubscription[0]);
            if (organization) {
                getBlocksByOrganizationId(organization.id);
            }
        }
    }, [blockSubscription]);

    useEffect(() => {
        if (auditorSubscription && auditorSubscription[0] !== undefined && auditorSubscription[0] !== currentAuditorSubscriptionItem) {
            setCurrentAuditorSubscriptionItem(auditorSubscription[0]);
            if (organization) {
                getOrganizationAuditorsAndFilter(organization);
            }
        }
    }, [auditorSubscription]);

    const calculateValues = (currentMessageBody?: (string | null), currentSelectedOrganizationAuditors?: (OrganizationAuditor[] | null), file?: (File | null)) => {
        setIsCountingCredits(true);

        let body = (currentMessageBody !== null && currentMessageBody !== undefined) ? currentMessageBody : messageBody;
        let subscribers = currentSelectedOrganizationAuditors || selectedOrganizationAuditors;
        let imageFile = file || image;

        const isGSM = checkIfMessageBodyCanBeEncodedInGSM(messageBody);
        setIsEncodedWithGSM(isGSM);
        const charCount = body.length;
        const messageSegmentCount = calculateTotalMessageSegmentsInMessageBody(messageBody);

        if (body === "" && !imageFile) {
            setCharacterCount(0);
            setMessageSegmentCount(0);
            setCreditsNeeded(0);
            setIsEncodedWithGSM(true);
        } else if (body === "" && imageFile) {
            const newSegmentCount = 2;
            setMessageSegmentCount(newSegmentCount);
            if (subscribers) {
                setCreditsNeeded(subscribers?.length * newSegmentCount);
            }
        } else if (body !== "" && !imageFile) {
            setCharacterCount(charCount);
            setMessageSegmentCount(messageSegmentCount);
            if (subscribers) {
                setCreditsNeeded(subscribers?.length * messageSegmentCount);
            }
        } else {
            const newSegmentCount = messageSegmentCount + 2;
            setCharacterCount(charCount);
            setMessageSegmentCount(newSegmentCount);
            if (subscribers) {
                setCreditsNeeded(subscribers?.length * newSegmentCount);
            }
        }
        setIsCountingCredits(false);
    }

    const handleOptionChange = (value: string) => {
        setIsGeneral(value === "general");
        setIsFiltered(value === "filtered");
        setIsCustom(value === "custom");

        if (value === "custom") {
            // If custom, start with no selected auditors
            setSelectedOrganizationAuditors([]);
            calculateValues(undefined, []);
        } else {
            // otherwise, set Auditors to "all"
            setSelectedOrganizationAuditors(organizationAuditors);
            calculateValues(undefined, organizationAuditors);
        }
    }

    const handleRoleFilterSelect = async (formattedOptions: FormattedRoleOption[]) => {
        setIsCountingCredits(true);
        setFormattedRoleOptions(formattedOptions);
        if (organizationAuditors) {
            const queryResult = await getOrganizationAuditorsByFilters(organizationAuditors, formattedOptions, (formattedFilters || undefined));
            if (queryResult.isSuccess) {
                setSelectedOrganizationAuditors(queryResult.result);
                calculateValues(undefined, queryResult.result);
            }
        }
        else {
            setError("Could not find any subscribers to filter. Try reloading the page.");
        }
        setIsCountingCredits(false);
    }

    const handleFilterSelect = async (formattedFilters: FormattedFilter[]) => {
        setIsCountingCredits(true);
        setFormattedFilters(formattedFilters);
        if (organizationAuditors && formattedRoleOptions) {
            const queryResult = await getOrganizationAuditorsByFilters(organizationAuditors, formattedRoleOptions, formattedFilters);
            if (queryResult.isSuccess) {
                setSelectedOrganizationAuditors(queryResult.result);
                calculateValues(undefined, queryResult.result);
            }
        }
        else {
            setError("Could not find any subscribers to filter. Try reloading the page.");
        }
        setIsCountingCredits(false);
    }

    const handleSelectCustomOrganizationAuditors = (selected: OrganizationAuditor[]) => {
        setSelectedOrganizationAuditors(selected);
        calculateValues(undefined, selected);
    }

    const handleMessageBodyChange = (value: string) => {
        setMessageBody(value);
        calculateValues(value);
    }

    const getImageKey = (image: File) => {
        if (image.type === "application/pdf") {
            return createMMSPDFFileName(organization);
        } else {
            return createMMSPictureFileName(organization, image);
        }
    }

    const getImageURL = (imageKey: string) => {
        return "https://" + awsmobile.aws_user_files_s3_bucket + ".s3.amazonaws.com/public/" + imageKey;
    }

    const uploadImageToS3 = async (imageKey: string) => {
        let imageUploadResult: Result | undefined = await handleUploadS3Image(imageKey, image);
        if (imageUploadResult && imageUploadResult.isSuccess) {
            const key = imageUploadResult.result;
            if (key) {
                return key;
            }
        } else {
            return null;
        }
    }

    const handleImageChange = (file: File | null | undefined) => {
        setImageMessage("");
        setError("");
        if (file) {
            const fileSizeInBytes = file.size;
            if (fileSizeInBytes >= 3000000) {
                setError("Sorry, this file is too large to send. Please use a file smaller than 3MB.");
            } else {
                setImage(file);

                const fileSizeString = formatBytes(fileSizeInBytes);

                if (fileSizeInBytes >= 1000000) {
                    setImageMessage(`WARNING: this file may not be received by all users. Some carriers do not allow files of this size: ${fileSizeString}. We recommend trying a smaller size file (taking a screenshot or using jpg may make the file size smaller.)`);
                } else {
                    setImageMessage(`File size: ${fileSizeString}`);
                }

                // Allow an update to the message body if an image is uploaded
                let updatedMessageBody = messageBody;
                // Get the key and url
                const imageKey = getImageKey(file);
                if (imageKey) {
                    const imageURL = getImageURL(imageKey);
                    // Update the message body to include to new URL - user can choose to remove it 
                    updatedMessageBody = messageBody + (messageBody.length > 0 ? "\n" : "") + "(View: " + imageURL + ")"; 
                }
                setMessageBody(updatedMessageBody);
                calculateValues(updatedMessageBody, organizationAuditors, file);
            }
        } else {
            setImage(undefined);
            let updatedMessageBody = messageBody;
            if (messageBody.includes("(View: ")) {
                const splitMessageBody = updatedMessageBody.split("(View: ");
                updatedMessageBody = splitMessageBody[0];
                setMessageBody(updatedMessageBody);
            }
            calculateValues(updatedMessageBody, organizationAuditors);
        }
    }

    function formatBytes(bytes: number, decimals = 2) {
        if (!+bytes) return '0 Bytes';
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }

    const sendAlertToAuditors = async () => {        
        // Confirm there are enough credits to send the alert
        if (totalCreditCount < creditsNeeded) {
            setError("You do not have enough credits to send this message.");
            return false;
        }

        // Track the credit blocks remaining credits
        let blockArray = formattedBlocks;
        let blockIdArray: string[] = [];
        blockArray?.forEach((block: FormattedBlock) => {
            blockIdArray.push(block.id);
        });

        // Handle image if it is included
        let imageURL = "";
        let imageKey = "";
        try {
            if (image) {
                imageKey = await getImageKey(image);
                await uploadImageToS3(imageKey);
                imageURL = getImageURL(imageKey);
            }
        } catch (error) {
            setError("Sorry - we could not add the file to the message. Please refresh the page and try again.");
            setIsLoading(false);
            return;
        }

        // Create the alert
        const alertInput: CreateAlertInput = {
            body: messageBody,
            imageKey: imageKey,
            organizationId: organization.id || "",
            messageSegments: messageSegmentCount,
            subscriberCount: selectedOrganizationAuditors?.length || 0,
            createdBy: user.id
        };
        const createAlertResult = await createAlert(alertInput);
        if (createAlertResult.isSuccess) {
            const alert: Alert = createAlertResult.result;

            // Remove the assumed number of credits. If any texts fail to send - will be handled within the Lambda Function
            setTotalCreditCount(totalCreditCount - creditsNeeded);

            if (selectedOrganizationAuditors) {
                let phoneNumberList: string[] = [];
                selectedOrganizationAuditors.forEach(organizationAuditor => {
                    if (organizationAuditor.phoneNumber) phoneNumberList.push(organizationAuditor.phoneNumber);
                });

                // Mass data to Lambda Function
                handleSendMassOrgSMS(alert.id, phoneNumberList, blockIdArray, false, messageBody, imageURL);
            }    

            setSuccess("Successfully created the text alert!");  
            setMessageBody("");
            setImage(undefined);
            calculateValues("");     
        } else {
            const errorMessage = "Sorry, we could not create this message. " + createAlertResult.message;
            setError(errorMessage);
        }
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        setError("");
        setSuccess("");
        await sendAlertToAuditors();
        setIsLoading(false);
        setShowModal(false);
    }

    const scheduleAlertToAuditors = async () => {        
        // Confirm there are enough credits to schedule the alert
        if (totalCreditCount < creditsNeeded) {
            setError("You do not have enough credits to schedule this message.");
            return false;
        }

        // Track the credit blocks remaining credits
        let blockArray = formattedBlocks;
        let blockIdArray: string[] = [];
        blockArray?.forEach((block: FormattedBlock) => {
            blockIdArray.push(block.id);
        });

        // Handle image if it is included
        let imageURL = "";
        let imageKey = "";
        try {
            if (image) {
                imageKey = await getImageKey(image);
                await uploadImageToS3(imageKey);
                imageURL = getImageURL(imageKey);
            }
        } catch (error) {
            setError("Sorry - we could not add the file to the message. Please refresh the page and try again.");
            setIsLoading(false);
            return;
        }

        // Create the date time string
        const dateTimeString = handleConvertDateTimeToUTC();
        console.log("dateTimeString: ", dateTimeString);

        let phoneNumberList: string[] = [];
        if (selectedOrganizationAuditors) {
            selectedOrganizationAuditors.forEach(organizationAuditor => {
                if (organizationAuditor.phoneNumber) phoneNumberList.push(organizationAuditor.phoneNumber);
            });
        }  

        // Create the alert
        const alertInput: CreateAlertInput = {
            body: messageBody,
            imageKey: imageKey,
            organizationId: organization.id || "",
            messageSegments: messageSegmentCount,
            subscriberCount: selectedOrganizationAuditors?.length || 0,
            sentFromPhoneNumber: "+17572106404",
            recipientPhoneNumbers: phoneNumberList,
            totalCost: 0, //To Do: 
            fromUnlimitedEvent: false, //Org does not have unlimited credits available right now
            scheduleDateTime: dateTimeString,
            createdBy: user.id
        };
        console.log("alertInput: ", alertInput);
        const createAlertResult = await createAlert(alertInput);
        console.log("createAlertResult: ", createAlertResult);
        if (createAlertResult.isSuccess) {
            const alert: Alert = createAlertResult.result;
            // Remove the assumed number of credits. If any texts fail to send - will be handled within the Lambda Function
            setTotalCreditCount(totalCreditCount - creditsNeeded);
            setSuccess("Successfully created the text alert!");  
            setMessageBody("");
            setImage(undefined);
            calculateValues("");     
        } else {
            const errorMessage = "Sorry, we could not create this message. " + createAlertResult.message;
            setError(errorMessage);
        }
    }

    const handleDateChange = (date: string | null | undefined) => {
        setScheduleError("");
        // First, check if the date is before today
        const todayDate = moment(new Date()).format(dateFormat);
        const isSelectedDateBeforeToday = moment(date).isBefore(todayDate);
        if (isSelectedDateBeforeToday) {
            setScheduleError("You cannot schedule a send for a date that is before today.");
            return;
        }
        setScheduleDate(date);
    }

    const handleTimeChange = (t: string | null | undefined) => {
        setScheduleError("");

        // Check if the day is same as today - then check if the time is before now
        const todayDate = moment(new Date()).format(dateFormat);

        if (moment(scheduleDate).isSame(todayDate, "day")) {
            const currentTime = moment(new Date());
            const scheduledTimeMoment = moment(t, "h:mm a");
            const isSelectedTimeBeforeNow = scheduledTimeMoment.isBefore(currentTime);
            if (isSelectedTimeBeforeNow) {
                setScheduleError("You cannot schedule a send for a time that is before now.");
                return;
            }
        }
        setScheduleTime(t);
    }

    const handleConvertDateTimeToUTC = () => {
        const dateTimeString = scheduleDate + " " + scheduleTime + " " + getCurrentTimeZoneDisplayString();
        const dateTimeMoment = moment(dateTimeString, "YYYY-MM-DD h:mm a Z");
        const dateTimeMomentUTC = dateTimeMoment.utc();
        const dateTimeMomentUTCString = dateTimeMomentUTC.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        return dateTimeMomentUTCString;
    }

    const handleScheduleSend = async () => {
        setIsLoading(true);
        setScheduleError("");
        setSuccess("");
        if (!scheduleDate || !scheduleTime) {
            setScheduleError("Please select both a date and time to schedule the send.");
            return;
        }
        await scheduleAlertToAuditors();
        setIsLoading(false);
        setShowModal(false);
    }

    const getCurrentTimeZoneDisplayString = () => {
        const date = new Date();
        const fullDateWithReadableTimeZone = date.toLocaleString('en-US', { timeZoneName: 'long' });
        const afterSplit = fullDateWithReadableTimeZone.split(', ')[1];
        const timeZoneName = afterSplit.split('PM')[1] || afterSplit.split('AM')[1]; 
        return timeZoneName;
    }

    return (
        <form>
            {error && <ErrorAlert width="12" error={error} />}
            {success && <SuccessBanner width="12" success={success} />}
            <IonRow>
                <IonCol className="ion-text-center">
                    <p className="description">Remember to refresh the page throughout the day to see new subscribers.</p>
                </IonCol>
            </IonRow>
            <IonRow className="pt-4 ion-justify-content-center">
                <IonCol sizeXs="12" sizeMd="4" className="ion-text-center">
                    <IonButton color={isGeneral ? "primary" : "light"} onClick={() => handleOptionChange("general")}>All</IonButton>
                </IonCol>
                <IonCol sizeXs="12" sizeMd="4" className="ion-text-center">
                    <IonButton color={isFiltered ? "primary" : "light"} onClick={() => handleOptionChange("filtered")}>Filter</IonButton>
                </IonCol>
                <IonCol sizeXs="12" sizeMd="4" className="ion-text-center">
                    <IonButton color={isCustom ? "primary" : "light"} onClick={() => handleOptionChange("custom")}>Custom</IonButton>
                </IonCol>
            </IonRow>
            <hr/>
            {isCustom && (
                <>
                    {organizationAuditors && (
                        <>
                            <SelectEventAuditors organizationAuditors={organizationAuditors} onSelect={handleSelectCustomOrganizationAuditors} />
                            <hr/>
                        </>
                    )}
                </>
            )}
            {isFiltered && (
                <>
                    {organizationAuditors && (
                        <>
                            <InformationBanner info={"If a subscriber has selected at least 1 filter that matches your selections, they will get the alert."} />
                            <SelectEventFilterRolesOptionForm organizationId={organization.id} startWithoutSelections={false} isCollapsable={true} isExpandedOnStart={false} onSelect={handleRoleFilterSelect} />
                            <SelectEventAlertFiltersForm organization={organization} onSelect={handleFilterSelect} />
                            <hr/>
                        </>
                    )}
                </>
            )}
            <IonRow className="ion-justify-content-center">
                <IonCol size="12" className="ion-text-center">
                    <h2 className="text-primary ion-text-wrap">Credits Available:</h2>
                </IonCol>
                <IonCol size="12" className="ion-text-center">
                    <p className="description text-primary">
                        <span className="font-weight-bold">{totalCreditCount.toLocaleString()} credits.</span> 
                    </p>
                    {((organizationAuditors?.length ? organizationAuditors?.length > 0 : "") && (totalCreditCount < (organizationAuditors?.length ? (organizationAuditors?.length + organizationAuditors?.length*.5) : 0))) && (
                        <IonRow className="ion-justify-content-center">
                            <IonCol size="12" className="ion-text-center">
                                <p className="description text-danger">Running low on credits: <span className="link" onClick={() => setShowCreditModal(!showCreditsModal)}>Add Credits</span></p>
                            </IonCol>
                        </IonRow>
                    )}
                </IonCol>
            </IonRow>

            {isCountingCreditsNeeded ?
                <Spinner />
                :
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12" className="ion-text-center">
                        <h2 className="text-primary ion-text-wrap">Credits You Will Use:</h2>
                    </IonCol>
                    <IonCol size="12" className="ion-text-center">
                        <p className="description text-primary">
                            <span className="font-weight-bold">{creditsNeeded.toLocaleString()} credits</span>
                        </p>
                        <p className="description text-primary">
                            (This message will go to {(selectedOrganizationAuditors)?.length.toLocaleString()} subscribers)
                        </p>
                        <p className="description text-primary">
                            (This message counts as {messageSegmentCount.toLocaleString()} alerts)
                        </p>
                    </IonCol>
                </IonRow>
            }
            {isFiltered && (
                <IonRow className="ion-justify-content-center">
                    <IonCol size="10" className="ion-text-center">
                        <p className="description link" onClick={() => setShowModal(true)}>View who will receive the alert.</p>
                    </IonCol>
                </IonRow>
            )}
            <hr/>
            <IonRow>
                <label>
                    Attachment (optional)
                </label>
            </IonRow>
            <AlertImageForm selectedImage={image} onSelect={handleImageChange}/>
            {imageMessage && (
                <p className="description text-center text-warning">{imageMessage}</p>
            )}
            <hr/>
            <IonRow>
                <IonCol>
                    <FormGroup>
                        <label
                            className="form-control-label"
                            htmlFor="body"
                        >
                            Message
                        </label>
                        <Input
                            id="body"
                            placeholder="..."
                            rows="4"
                            type="textarea"
                            name="body"
                            className={(characterCount > 900) ? "form-text-input-not-allowed" : ((messageSegmentCount > 1) ? "is-invalid" : "")}
                            value={messageBody}
                            onChange={(event) => handleMessageBodyChange(event.target.value)}
                        />
                        <div>
                            <p className="text-right">{characterCount}/{(isEncodedWithGSM ? "160" : "70")}</p>
                        </div>                        
                    </FormGroup>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol>
                    {/* Explain why non-GSM characters change the way message segments are calculated. */}
                    {(!isEncodedWithGSM) &&
                        <p className="description text-center text-danger">
                            Note: You may include special characters (ex: emojis, accented letters, etc.), but it changes how many characters are used per alert.
                        </p>
                    }

                    {/* Check that the message is not over the limit of 900 characters */}
                    {characterCount > 900 ? 
                        <p className="description text-center text-danger">
                            You cannot send this alert because it is too long.{" "}
                            Please shorten your message to less than 900 characters and try again.
                        </p>
                        :
                        <>
                            {characterCount >= 650 ?
                                <p className="description text-center text-danger">
                                    Messages over 650 characters will likely not be delivered to many subscribers.
                                </p>
                                :
                                <>
                                    {/* Check if the current organization has enough credits to send this alert. */}
                                    {((organizationAuditors?.length ? organizationAuditors?.length > 0 : "") && (totalCreditCount < (organizationAuditors?.length ? (organizationAuditors?.length + organizationAuditors?.length*.5) : 0))) ?
                                        <p className="description text-center text-danger">
                                            You do not have enough credits to send this alert.{" "}
                                            You can either delete some of the characters or purchase more credits.
                                        </p>
                                        :
                                        <>
                                            {/* There are enough credits to send the alert, but warn the user if the message is more than 1 segment. */}
                                            {(messageSegmentCount > 1) ?
                                                <>
                                                    <p className="description text-center">
                                                        You can send this alert and users will see it as one text message.
                                                    </p>
                                                    <p className="description text-center">
                                                        However, it will count as {messageSegmentCount} alerts in our system.
                                                    </p>
                                                </>
                                                :
                                                <></>
                                            }
                                        </>
                                    }
                                </>
                            }
                        </>
                    }
                    
                </IonCol>
            </IonRow>
            {error && <ErrorAlert width="12" error={error} />}
            {success && <SuccessBanner width="12" success={success} />}
            <IonRow className="ion-justify-content-center">
                <IonCol sizeMd="12">
                    {isLoading ?
                        <IonRow className="ion-justify-content-center">
                            <IonCol className="ion-text-center">
                                <p>Sending alerts, do not refresh page</p>
                                <Spinner />
                            </IonCol>
                        </IonRow>
                        :
                        <IonButton
                            disabled={(creditsNeeded === 0) || (characterCount > 1600)}
                            className="ion-margin-top"
                            color="tertiary"
                            expand="block"
                            onClick={() => handleSubmit()}
                        >
                            <span className="ion-text-wrap">{creditsNeeded === 0 ? "Type Message" : (characterCount > 1600) ? "Message Too Long" : "Send Now"}</span>
                        </IonButton>
                    }
                </IonCol>
            </IonRow>
            {/* Commmenting out scheduled alerts in Prod for now. */}
            {/* {!((creditsNeeded === 0) || (characterCount > 1600)) && (
                <>
                    <hr/>
                    {scheduleError && <ErrorAlert width="12" error={scheduleError} />}
                    <IonRow onClick={() => setShowScheduleOptions(!showScheduleOptions)}>
                        <label>
                            Schedule Send For Later
                        </label>
                        <label className="ion-text-right"><IonIcon icon={showScheduleOptions ? chevronUp : chevronDown} /></label>
                    </IonRow>
                    {showScheduleOptions && (
                        <>
                            <IonRow className="ion-justify-content-center">
                                <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="12" sizeXl="6">
                                    <ReactstrapDatePicker value={scheduleDate} onChange={(date: any) => {handleDateChange(date);}}/>
                                </IonCol>
                                <IonCol sizeXs="12" sizeSm="12" sizeMd="12" sizeLg="12" sizeXl="6">
                                    <ReactstrapTimePicker label="Time" selectedTime={scheduleTime} onChange={(time: string | null | undefined) => {handleTimeChange(time);}} />
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size="12" className="ion-text-center">
                                    <p className="description text-center text-danger">
                                        Your time zone is {getCurrentTimeZoneDisplayString()}
                                    </p>
                                </IonCol>
                            </IonRow>
                            <IonRow className="ion-justify-content-center">
                                <IonCol size="12" className="ion-text-center">
                                    <IonButton color="warning" expand="block" onClick={() => handleScheduleSend()}>Schedule Send</IonButton>
                                </IonCol>
                            </IonRow>
                        </>
                    )}
                </>
            )} */}
            <IonModal backdropDismiss={false} isOpen={showModal} id="viewSubscribersModal">
                <IonToolbar color="light">
                    <IonTitle className="ion-text-center">
                        Subscribers to Receive Alert
                    </IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            fill="clear"
                            onClick={() => setShowModal(false)}
                        >
                            <p id="closeSubscriberModalBtn" className="font-weight-normal text-medium text-capitalize">
                                <IonIcon icon={close} />
                            </p>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent className="ion-padding">
                    {isLoading ?
                        <Spinner />
                        :
                        <>
                            <InformationBanner info="Based on the current filters you've selected, these are the subscribers that will get the alert" />
                            {selectedOrganizationAuditors ?
                                <IonList className="bg-white">
                                    {selectedOrganizationAuditors.map((organizationAuditor: OrganizationAuditor, index: number) => (
                                        <IonItem key={index}>
                                            <IonLabel>
                                                <IonRow>
                                                    <IonCol size="1">
                                                        <p>{index+1}</p>
                                                    </IonCol>
                                                    <IonCol size="6" className="ion-text-wrap">
                                                        <p>{organizationAuditor.name}</p>
                                                    </IonCol>
                                                    <IonCol size="5" className="ion-text-wrap">
                                                        <p>{organizationAuditor.phoneNumber}</p>
                                                    </IonCol>
                                                </IonRow>
                                            </IonLabel>
                                        </IonItem>
                                    ))}
                                </IonList>
                                :
                                <p>There are no selected subscribers.</p>
                            }
                        </>
                    }
                </IonContent>
            </IonModal>
            <IonModal backdropDismiss={false} isOpen={showCreditsModal} id="addCreditsModal">
                <IonToolbar color="light">
                    <IonTitle className="ion-text-center">
                        Add Credits
                    </IonTitle>
                    <IonButtons slot="end">
                        <IonButton
                            fill="clear"
                            onClick={() => setShowCreditModal(false)}
                        >
                            <p id="closeCreditsModalBtn" className="font-weight-normal text-medium text-capitalize">
                                <IonIcon icon={close} />
                            </p>
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <IonContent className="ion-padding">
                    {isLoading ?
                        <Spinner />
                        :
                        <>
                            <IonRow className="ion-justify-content-center">
                                <IonCol size="8">
                                   {(organization) && 
                                        <BuyCreditsForm organizationId={organization.id} />
                                   }
                                </IonCol>
                            </IonRow>
                        </>
                    }
                </IonContent>
            </IonModal>
        </form>
    );
};

export default SendOrgAlertForm;